<template>
  <div class="transportDeliveryOrder">
    <!--内容区域-->
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>可放货额度单据明细</div>
        </template>
        <div class="collapse-content">
          <el-button type="primary" class="btn" @click="add">
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-add"
            />新增</el-button
          >
          <el-button type="primary" class="btn" @click="handleExport"
            ><svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-export"
            />导出</el-button
          >
          <sirui-table
            ref="siruiTable"
            :buttonList="menuButtonList"
            :loading="load"
            :data="tableData"
            :paging="true"
            :columns="columnList"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
            @handleSelectionChange="handleSelectionChange"
          >
            <vxe-table-column
              v-for="(item, index) in columnList"
              :key="index"
              :fixed="item.fixed"
              :visible="item.visible"
              :width="item.width || 120"
              :sortable="item.sortable"
              :field="item.field"
              :formatter="item.formatter"
              :params="item.params"
              :type="item.type"
              :title="item.title ? $t(item.title) : null"
            >
              <template slot-scope="scope">
                <span v-if="item.dictType">
                  {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
                </span>
                <span v-else-if="item.format">
                  {{ scope.row[item.field] | formatTableColumn(item.format) }}
                </span>
                <span v-else>{{ scope.row[item.field] }}</span>
              </template>
            </vxe-table-column>
          </sirui-table>
        </div>
      </el-collapse-item>
    </el-collapse>
    <creatDialog ref="creatDialog" :dialogData="dialogData" @confirm="confirm" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/orderLadingLimit.js';
  import DataBaseAPI from '@/api/dataBase';
  // import tableMixins from "@/common/mixins/table.js";
  // import loading from '@/common/js/load.js'; //loading
  import creatDialog from './components/creatDialog';
  import SiruiTable from '@/components/SiruiTable';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'orderLadingLimitDetail',
    // mixins: [tableMixins],
    components: {
      creatDialog,
      SiruiTable,
    },
    data() {
      return {
        load: false,
        activeNames: ['1'], //默认展开那些面板，
        companyList: [], //公司列表
        departmentList: [], //部门列表
        dialogData: null,
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        rowData: {}, //被选中的列
        exportAction: API.EXPORT_ORDER_LADING_DETAIL,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
        baseUrl() {
          return baseUrl;
        },
      }),
      //表格显示字段
      columnList() {
        return [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          { field: 'orderCompanyName', title: '公司', visible: true, width: 220 },
          { field: 'orderDepartmentName', title: '部门', visible: true },
          {
            field: 'orderType',
            title: '单据类型',
            visible: true,
            type: 'dict',
            dictType: 'LADING_LIMIT_ORDERTYPE',
          },
          { field: 'orderNo', title: '单据编号', visible: true, width: 180 },
          { field: 'partnerName', title: '客户', visible: true, width: 220 },
          {
            field: 'currencyCode',
            title: '币种',
            visible: true,
            // dictType: "all_currency",
            width: 180,
          },
          {
            field: 'receiveAmount',
            title: '收款',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'refundAmount',
            title: '退款',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'ladingAmount',
            title: '发货金额',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'salesReturnAmount',
            title: '销售退货',
            visible: true,
            format: 'formatAmountRound',
          },
          { field: 'remark', title: '描述', visible: true, width: 260 },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      console.log('listDetail');
      this.getData();
      this.getCompany();
    },
    methods: {
      //获取数据
      getData() {
        console.log('listDetail查看详情');
        const routerQuery = this.$route.query;
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        const query = { ...routerQuery, pageSize, pageNum };
        this.load = true;
        this.$axios.post(API.LADING_LIMIT_DETAIL_API, query).then((res) => {
          this.load = false;
          console.log(res);
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //搜索
      detailBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      // 弹窗确认
      confirm() {
        this.getData();
      },
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
        this.departmentList = [];
        this.query.inboundDepartmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      // 获取部门
      getdepartmentList(companyCode) {
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //新增
      add() {
        console.log(this.$router);
        this.$refs.creatDialog.defaultVisible = true;
        const query = this.$route.query;
        // this.$refs.creatDialog.formData.partnerNo=query.partnerNo;
        // this.$refs.creatDialog.formData.partnerName=query.partnerName;
        // this.$refs.creatDialog.formData.currencyCode=query.currencyCode;
        console.log('add');
        console.log(query);
        this.dialogData = query;
        // this.$refs.creatDialog.getDetail(query)
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      handleExport() {
        const routerQuery = this.$route.query;
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        let query = this.filterEmpty(routerQuery);
        Object.keys(query).forEach((value) => {
          if (XEUtils.isArray(query[value])) {
            query[value + 'Str'] = query[value].join(',');
            delete query[value];
          }
        });
        const params = XEUtils.serialize(query);
        window.location.href = `${this.baseUrl}${this.exportAction}?${params}&access_token=${this.tokenInfo.access_token}`;
        /* const selectedList = this.$refs.table.getCheckboxReserveRecords(); // 历史选中数据
      let changeList = this.multipleSelection.concat(selectedList);
      if (changeList.length > 0) {
        let str = ''
        let ids = changeList.forEach(item => {
          str += 'ids=' + item.id + '&';
        });
        let params = {
          ids: JSON.stringify(ids),
          access_token: this.token.access_token
        };
        window.location.href = `${this.baseUrl}${
          API.EXPORT_ORDER_LADING_DETAIL
        }?${str}access_token=${this.token.access_token}`;
      } else {
        const params = XEUtils.serialize(this.searchForm);
        window.location.href = `${this.baseUrl}${
          API.EXPORT_ORDER_LADING_DETAIL
        }?${params}&access_token=${this.token.access_token}`;
      } */
      },

      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: '可放货额度列表',
            },
          },
          toPath: {
            path: '/credit/orderLadingLimitList',
            name: 'orderLadingLimitList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .btn {
    // width: 36px;
    margin-bottom: 5px;
  }
  .collapse-content {
    border-top: 1px solid #e9ebf0;
    padding: 10px 20px 0px 20px;
  }
</style>
